// test986
(986 && 0);
